export default {
  data() {
    return {
      lengths: {
        uploadingAudio: 0,
        uploadingVisual: 0,
        visual: 0,
      },
    };
  },

  watch: {
    lightboxUploadingVoiceOverAssets: {
      immediate: true,
      deep: false,
      handler(value) {
        this.$data.lengths.uploadingAudio = value.length;
      },
    },

    lightboxUploadingAssets: {
      immediate: true,
      deep: false,
      handler(value) {
        this.$data.lengths.uploadingVisual = value.length;
      },
    },

    selectedAssets: {
      immediate: true,
      deep: false,
      handler(value) {
        this.$data.lengths.visual = value.length;
      },
    },

    'lengths.uploadingAudio'(now, was) {
      if (now > was) {
        this.$nextTick(this.$_scrollTo_audioSection);
      }
    },

    'lengths.uploadingVisual'(now, was) {
      if (now > was) {
        this.$nextTick(this.$_scrollTo_visualSection);
      }
    },

    'lengths.visual'(now, was) {
      if (now > was) {
        this.$nextTick(this.$_scrollTo_visualSection);
      }
    },
  },

  methods: {
    $_scrollTo_audioSection() {
      if (!this._isDestroyed) {
        const $el = this.$refs.audioSection;
        $el?.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // vertical alignment
        });
      }
    },

    $_scrollTo_visualSection() {
      if (!this._isDestroyed) {
        const $el = this.$refs.visualSectionTitle || this.$refs.visualSection;
        $el?.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // vertical alignment
        });
      }
    },
  },
};
